import React, { useState } from "react";
import { Grid, GridItem, Box, Center, Text, VStack, Link, StackDivider, HStack, useColorModeValue, Flex, Circle, Heading } from "@chakra-ui/react";
import Draggable from 'react-draggable';
import './skills.css'
import reportPDF from "../assets/DHIRAJ PATIL RESUME U_BUFFALO.pdf"

const MainContent = ({ updateCurScreen }) => {
    
return ( <GridItem 
              colSpan={4} bg='#F2F1EB' px='15%'
            >
            <VStack
              divider={<StackDivider borderColor='gray.200' />}
              spacing={4}
              align='stretch'
            >
              <HStack justifyContent='space-between' align='baseline'>
                <Text paddingTop='5%' fontSize='2.5rem' fontWeight='bold' fontFamily='Roboto, sans-serif' color='#333' lineHeight='1.2rem'>
                  Dhiraj Patil
                </Text>
                <HStack>
                  <Center border='2px solid #777' rounded='6px' p={2} onClick={() => updateCurScreen(1)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M21 7v10c0 3-1.5 5-5 5H8c-3.5 0-5-2-5-5V7c0-3 1.5-5 5-5h8c3.5 0 5 2 5 5Z" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.5 4.5v2c0 1.1.9 2 2 2h2M8 13h4M8 17h8" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  </Center>
                  {/* <Center border='2px solid #777' rounded='6px' p={2} onClick={() => updateCurScreen(2)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M9 22h6c5 0 7-2 7-7V9c0-5-2-7-7-7H9C4 2 2 4 2 9v6c0 5 2 7 7 7Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM2.67 18.95l4.93-3.31c.79-.53 1.93-.47 2.64.14l.33.29c.78.67 2.04.67 2.82 0l4.16-3.57c.78-.67 2.04-.67 2.82 0L22 13.9" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  </Center> */}
                </HStack>
                </HStack>
              <HStack backgroundColor='#ddd' rounded='4px' w='100%' fontFamily='Roboto, sans-serif'>
                <Text fontSize='2rem' paddingStart={10}>📱</Text>
                <VStack w='100%' align='start'>
                  <span><strong>Email</strong>: dhiraj@dhiraj.xyz </span>
                  <span>
                    <Link href="https://x.com/feuledByVadapav" color='#0F0F0F' isExternal>X</Link> | <Link href="https://www.linkedin.com/in/dhiraj-patil-6b636a1b5/" color='#0F0F0F' isExternal>Linkedin</Link>
                  </span>
                </VStack>
              </HStack>
              <Text
                fontSize='1.2rem'
                fontFamily='Roboto, sans-serif'
                color='#333'
                lineHeight='2rem'
              >
                I’ve been programming since 2018 or so, and I try to have a somewhat public profile on the things I do.
                i'm interested in building my own products mainly.
                In the time after, i've been fortunate enough to work with and learn from incredible 
                founders/entrepreneurs around the world - which has seeded a lot in my work and thinking.
                I do my best work when working with ambitious, mission-driven teams.
              </Text>
              <Text
                fontSize='1.2rem'
                fontFamily='Roboto, sans-serif'
                color='#333'
                lineHeight='2rem'
              >
                Previously I was working on <Link href="https://newtrun.com/" color='#0F0F0F' isExternal>Newtrun</Link> to accelerate everything related to logistics with software.
              </Text>
              <Text
                fontSize='1.2rem'
                fontFamily='Roboto, sans-serif'
                color='#333'
                lineHeight='2rem'
              >
                This website will always be a work in progress. I sometimes write blogs which are posted here, 
                but now I spend most of my time working on other things. I plan to start writing again, 
                mostly to capture a trend of changes in my thinking.
              </Text>
              <Text
                fontSize='1rem' fontStyle='italic'
                fontFamily='Roboto, sans-serif' fontWeight='bold'
                color='#000' paddingBottom={80}
              >
                show the world how software works for you.
              </Text>
            </VStack>
    </GridItem> 
  );
}

const TimelineItem = ({ period, title, company, description, isLast }) => {
  return (
    <Flex w="100%">
      {/* Left side - Bullet and Line */}
      <Flex flexDir="column" alignItems="center" mr={4} position="relative" >
        <Circle size="12px" bg={'#555555'} marginTop="20px" />
        {!isLast && (
          <Box
            position="absolute"
            top="32px"
            width="2px"
            height="calc(100% - 12px)"
            bg={'#555555'}
            opacity={0.6}
          />
        )}
      </Flex>
      
      {/* Right side - Content */}
      <Box flex={1} pb={isLast ? 0 : 8} paddingLeft='5%'>
        <Text fontSize="sm" fontWeight="bold" color={'#555555'} fontFamily='Roboto, sans-serif'>
          {period}
        </Text>
        <Heading size="sm" mt={1} mb={2} color={'#555555'} fontFamily='Roboto, sans-serif'>
          {title}
        </Heading>
        <Text fontSize="md" fontWeight="medium" color={'#555555'} mb={2} fontFamily='Roboto, sans-serif'>
          {company}
        </Text>
        {description.map((item, index) => (
          <Text key={index} fontSize="sm" color={'#555555'} fontFamily='Roboto, sans-serif'>
            {item}
          </Text>
        ))}
      </Box>
    </Flex>
  );
};

const ResumeContent = ({ updateCurScreen }) => {

  const resumeData = [
    {
      id: 1,
      period: "2024 - Present",
      title: "Student Assistant",
      company: "University At Buffalo",
      description: ["Provide technical support and manage logistics for K-12 Cohort, under Empire State Service Corp initiative dedicated to providing academic services aimed at fostering student success and academic excellence."]
    },
    {
      id: 2,
      period: "2024 - 2025",
      title: "University At Buffalo",
      company: "M.S in Computer Science",
      description: ["Coursework: Algorithms & Problem Solving, Machine learning with Generative Models, Big Data, Operating Systems, Security, Architecture, Networking."]
    },
    {
      id: 3,
      period: "2022 - 2024",
      title: "Software Engineer",
      company: "Newtrun Labs",
      description: ["Developed scalable web applications (NextJS/React) and data pipelines (3M+ daily records) resulting in faster feature delivery and real-time shipment tracking.",
        "Engineered CI/CD pipelines, security frameworks (OAuth/JWT in Python), and payment gateway integrations for seamless, secure, and efficient platform operations.",
        "Collaborated with scrum and agile methods across cross-functional teams, including clients, business teams and product managers, to deliver high-quality software solutions."
      ]
    },
    {
      id: 4,
      period: "2021 - 2022",
      title: "Fullstack Development Intern",
      company: "Yunicorp Technologies",
      description: ["Designed, developed, and launched 3 Flutter/Firebase mobile applications for a healthcare startup, enabling MVP-driven seed funding and initial beachhead market testing, accelerating product delivery in a fast-paced environment.",
        "Engineered high-reliability payment gateway integrations (95% success rate on 250 daily transactions) and real-time bidirectional data exchange (250-300ms response, 95% consistency) via Firebase APIs."
      ]
    },
    {
      id: 4,
      period: "2019 - 2023",
      title: "University of Mumbai",
      company: "B.S in Computer Engineering",
      description: ["Coursework: Data Structures & Algorithms, Object oriented programming, database, Mobile computing, Microprocessor, software engineering"]
    },
  ];

  const handleDownload = () => {
    fetch(reportPDF)
      .then((res) => res.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "DHIRAJ PATIL RESUME U_BUFFALO.pdf";
        a.click();
        window.URL.revokeObjectURL(url);
      });
  };

  return (
    <GridItem 
      colSpan={4} bg='#F2F1EB' px='15%'
    >
      <VStack
        divider={<StackDivider borderColor='gray.200' />}
        spacing={4}
        align='stretch'
        paddingTop='5%'
      >
        <HStack justifyContent='space-between' maxW='75%'>
          <Center border='1px solid #777' rounded='4px' p={2} px={8} onClick={() => updateCurScreen(0)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"><path stroke="#555555" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M9.57 5.93L3.5 12l6.07 6.07M20.5 12H3.67"></path></svg>  
          </Center>
          <Center border='1px solid #777' rounded='4px' p={2} px={8} onClick={() => handleDownload()} bg='#777'>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"><path stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.44 8.9c3.6.31 5.07 2.16 5.07 6.21v.13c0 4.47-1.79 6.26-6.26 6.26H8.74c-4.47 0-6.26-1.79-6.26-6.26v-.13c0-4.02 1.45-5.87 4.99-6.2M12 2v12.88"></path><path stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.35 12.65L12 16l-3.35-3.35"></path></svg> 
          </Center>
        </HStack>
        <VStack spacing={0} align="stretch" paddingTop='5%' paddingBottom='15%' maxW='75%'>
          {resumeData.map((item, index) => (
            <TimelineItem
              key={item.id}
              period={item.period}
              title={item.title}
              company={item.company}
              description={item.description}
              isLast={index === resumeData.length - 1}
            />
          ))}
        </VStack>
      </VStack>
    </GridItem>
  );
}

const ImageContent = ({ updateCurScreen }) => {
  return (
    <Text>SECOND SCREEN</Text>
  );
}

const Skills = (props) => {
  const[window, setWindow] = useState('windowed');
  const[isMax, setMax] = useState(false);
  const [x, setX]= useState(0);
  const [y, setY]= useState(0);
  const [originalX, setOriginalX] = useState(0);
  const [originalY, setOriginalY] = useState(0);
  const [curScreen, setCurScreen] = useState(0);

  function updateCurScreen(screenValue) {
    setCurScreen(screenValue);
  }

  function onTrigger(event) {
    props.parentCallback(false, "showHideSkills");
    event.preventDefault();
  }

  function onTriggerMax(event) {
    if(isMax === false) {
      setX(0);
      setY(0);
      setOriginalX(x);
      setOriginalY(y);
      setWindow('fullscreen');
      setMax(true);
    } else {
      setX(originalX);
      setY(originalY);
      setWindow('windowed');
      setMax(false);
    }
    event.preventDefault();
  }

  function onTriggerTwo(event) {
    props.parentCallbackTwo(1, 0, 0, 0, 0);
    event.preventDefault();
  }

  const handleStop = (event, dragElement) => {
    setX(dragElement.x)
    setY(dragElement.y)
    event.preventDefault();
  };

  return (
    <Draggable 
      handle="#titlebar"
      bounds="body"
      cancel="#window-controls"
      onStop={handleStop} 
      position={{x: x, y: y}}
    >

      <div id="skills_window" className={window} onClick={onTriggerTwo} style={{zIndex: props.data}}>

        <header id="titlebar">

          <div id="window-title">
            <span><b>ABOUT</b></span>
          </div>

          <div id="window-controls">
            <div className="button" id="max-button" title="Maximize" onClick={onTriggerMax}>
            </div>
            <div className="button" id="close-button" title="Close" onClick={onTrigger}>
            </div>
          </div>

        </header>

        <Grid
          h='calc(100% - 30px)'
          mt='30px'
          templateRows='repeat(2, 1fr)'
          templateColumns='repeat(4, 1fr)'
          overflowY='scroll'
          sx={
            { 
              '::-webkit-scrollbar':{
                width: '6px'
              },
              "::-webkit-scrollbar-thumb": {
                backgroundColor: "#C7B7A3",
                borderRadius: "8px",
              },
           }
         }
        >
          {curScreen === 0 ? <MainContent updateCurScreen={updateCurScreen} /> : curScreen === 1 ? <ResumeContent updateCurScreen={updateCurScreen} /> : curScreen === 2 ? <ImageContent updateCurScreen={updateCurScreen} /> : <MainContent updateCurScreen={updateCurScreen} /> }
        </Grid>

        {/* People

          Be kind, be direct, be transparent and mainly be forgiving. They are living the same life you are for the 
          first time.
          Find people who will take you forward with them.

          
          What motivates me?
          
          To be honest, I dont know. I have not idea how to put it. it's the dreams i've had as a kid, promises i've
          made myself along the way. there are few things in life you dont why but you just want to do it. This is one of them.

          
          <div id="content_skills">
            {/* <ul className="list">
              <li>Python</li>
              <li>C</li>
              <li>React</li>
              <li>Node</li>
              <li>Java</li>
              <li>Android Studio</li>
            </ul> 
            <div id="content_skills_header">
              <h1>Hi, I'm Dhiraj :D</h1>
              <img src={img_charm} width={140} height={125} alt="happy charmander" />  
            </div>
            <div id="content_skills_info">
              <p>
                This is my personal website, where I write blog posts regularly,
                and keep a tab on all the projects I’ve worked on.
              </p>
              <p>
                I’ve also been programming since 2017 or so, and I try to have a somewhat public profile on the things I do.
                Topics I’ve enjoyed here include Functional Programming, Web Programming, Distributed Programming, and Programming Languages.
                I’ve programmed in a plethora of languages, from C, to Haskell, Rust, Go, Scala, Java, Python, etc.
                having written small to large-ish projects in each of them.
              </p>
            </div>
          </div>
        */}

      </div>
    </Draggable>
  );
}

export default Skills;
